export const RequestStrategyEnum = {
  Default: 'default',
  Debounce: 'debounce',
  Abort: 'abort',
  Once: 'once',
} as const;
export type RequestStrategyEnum = (typeof RequestStrategyEnum)[keyof typeof RequestStrategyEnum];
